import { makeFilterParams } from '../../utils/helpers/helpers';
import httpClient from '../httpClient';

const getProjects = async (params) => {
  return await httpClient.get(
    '/term_document_contract_validation_selectors/projects/',
    {
      params: params,
    },
  );
};

const getRoles = async (params) => {
  return await httpClient.get(
    '/term_document_contract_validation_selectors/roles/',
    {
      params: params,
    },
  );
};

const getTerms = async (params) => {
  return await httpClient.get(
    '/term_document_contract_validation_selectors/terms/',
    {
      params: params,
    },
  );
};

const post = async (data) => {
  return await httpClient.post(`/term_document_contract_validation/`, data);
};

const get = async (id) => {
  return await httpClient.get(`/term_document_contract_validation/${id}/`);
};

const filter = async (query, page, pageSize, _sortBy, searchBy) => {
  return await httpClient.get(
    `/term_document_contract_validation/?page[number]=${page}&page[size]=${pageSize}`,
    makeFilterParams({ ...query, search: searchBy ? searchBy : null }),
  );
};

const getCounters = async (query) => {
  return await httpClient.get(
    `term_document_contract_validation/counters/`,
    makeFilterParams(query),
  );
};

const getValidationDetail = async (id) => {
  return await httpClient.get(
    `/term_document_contract_validation/${id}/validation_detail/`,
  );
};

const getAllValidationContractDetails = async () => {
  return await httpClient.get(
    `/term_document_contract_validation/validation_detail_list/`,
  );
};

const notify = async (id) => {
  return await httpClient.get(
    `/term_document_contract_validation/${id}/notify/`,
  );
};

const put = async (id, data) => {
  return await httpClient.put(
    `/term_document_contract_validation/${id}/`,
    data,
  );
};

const patch = async (id, data) => {
  return await httpClient.patch(
    `/term_document_contract_validation/${id}/`,
    data,
  );
};

const remove = async (id) => {
  return await httpClient.delete(`/term_document_contract_validation/${id}`);
};

export {
  post,
  getValidationDetail,
  getAllValidationContractDetails,
  notify,
  get,
  filter,
  getCounters,
  put,
  patch,
  remove,
  getProjects,
  getRoles,
  getTerms,
};
